import React, { useState, useEffect } from 'react';
import {
	Icon,
	Tooltip,
	TooltipManager,
	Button,
} from '@aoworld-aotech/components-react';
import { sendBeacon } from '@aoworld-aotech/digital-data';

export const DeliveryTooltip = ({ tooltipZIndex = 50 }) => {
	const [isOpen, setIsOpen] = useState(false);
	let blurTimeout;

	function getPlacement() {
		return window.innerWidth > 500 ? 'left' : 'bottom-start';
	}

	const [placement, setPlacement] = useState(getPlacement());

	useEffect(() => {
		const handleResize = () => {
			setPlacement(getPlacement());
		};

		window.addEventListener('resize', handleResize);

		return () => window.removeEventListener('resize', handleResize);
	}, []);

	const handleFocus = () => {
		clearTimeout(blurTimeout);
		setIsOpen(true);
	};

	const handleBlur = () => {
		blurTimeout = setTimeout(() => {
			setIsOpen(false);
		}, 200);
	};

	return (
		<>
			<TooltipManager
				id="delivery-tooltip"
				closeDelay={1}
				isOpen={isOpen}
				onFocus={handleFocus}
				onBlur={handleBlur}
				className={`z-${tooltipZIndex} inline align-middle`}>
				{({ referenceProps, tooltipProps }) => (
					<>
						{tooltipProps.isOpen
							? sendBeacon('TrackClick', {
									type: 'tooltip',
									name: 'Delivery Price Tooltip Hover/Click',
									section: 'price-pod',
							  })
							: null}
						<Button
							variant="link"
							className="text-cta-action ml-1"
							{...referenceProps}>
							<Icon icon="info" size="sm" />
						</Button>

						<Tooltip
							{...tooltipProps}
							hideCloseButton={true}
							placement={placement}
							maxWidth="xs"
							className={`z-${tooltipZIndex}`}>
							<p className="text-xs m-0 w-48 text-left relative font-regular">
								Estimated charge. Actual delivery costs may vary by date, time
								slot selection, geographical location, or if arriving in two
								deliveries when ordering more than one product.
							</p>
						</Tooltip>
					</>
				)}
			</TooltipManager>
		</>
	);
};
